module.exports = require('./helpers/bundle-url').getBundleURL('jsZAK') + "logo.c51670a8.svg";